import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { get, join, startCase } from 'lodash';
import Yup from 'yup';
import { TextFieldWrapper } from '../../common';
import { formatPhoneNumber } from '../../../util/helpers';

const PHONE_NUMBER = 'primaryPhoneNumber';

const getPhoneFieldName = (paths, fieldName) =>
  join([...paths, fieldName], '.');

class PhoneNumberField extends React.Component {
  handleBlur = () => {
    const { fieldName, paths, setFieldValue, values } = this.props;
    const phoneFieldName = getPhoneFieldName(paths, fieldName);
    const phoneNumber = get(values, phoneFieldName);

    return setFieldValue(phoneFieldName, formatPhoneNumber(phoneNumber));
  };

  render() {
    const { fieldName, label, required, paths } = this.props;

    return (
      <Field
        component={TextFieldWrapper}
        id={fieldName}
        label={startCase(label)}
        name={getPhoneFieldName(paths, fieldName)}
        onBlur={this.handleBlur}
        paths={[...paths, fieldName]}
        required={required}
      />
    );
  }
}

PhoneNumberField.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  fieldName: PropTypes.string,
  label: PropTypes.string,
  paths: PropTypes.array,
  required: PropTypes.bool,
};

const defaultConfig = {
  fieldName: PHONE_NUMBER,
  label: 'Primary phone number',
  required: false,
};

PhoneNumberField.defaultProps = {
  ...defaultConfig,
  paths: [],
};

export default PhoneNumberField;

export function getPhoneNumberValidation(config = defaultConfig) {
  const {
    fieldName = defaultConfig.fieldName,
    label = defaultConfig.label,
    required = defaultConfig.required,
  } = config;

  const phoneNumberSchema = Yup.string()
    .trim()
    .matches(/^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number (area code required).',
    });

  return {
    [fieldName]: required
      ? phoneNumberSchema.required(`${label} is required.`)
      : phoneNumberSchema,
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/form/PhoneNumberField.js